import type { WhatsAppSenderState } from '@/modules/settings/domain/channels/WhatsAppSenderState';

export class WhatsAppSender {
  constructor(
    readonly id: string,
    readonly phoneNumber: string,
    readonly state: WhatsAppSenderState,
    readonly canRestartRegistration: boolean,
  ) {}
}
